import { cn } from "../../lib/cn.js";

/**
 * shadcn/ui's Table.
 *
 * The container scrolls, not the page: Source Attribution is eighteen columns wide, and a
 * horizontally scrolling PAGE carries the sidebar and the date controls off-screen with
 * it. This is upstream's own `overflow-x-auto` wrapper, kept for exactly that reason.
 */
export function Table({ className, ...props }: React.ComponentProps<"table">): React.JSX.Element {
  return (
    <div className="relative w-full overflow-x-auto">
      <table className={cn("w-full caption-bottom text-sm", className)} {...props} />
    </div>
  );
}

export function TableHeader({ className, ...props }: React.ComponentProps<"thead">): React.JSX.Element {
  return <thead className={cn("[&_tr]:border-b", className)} {...props} />;
}

export function TableBody({ className, ...props }: React.ComponentProps<"tbody">): React.JSX.Element {
  return <tbody className={cn("[&_tr:last-child]:border-0", className)} {...props} />;
}

export function TableRow({ className, ...props }: React.ComponentProps<"tr">): React.JSX.Element {
  return (
    <tr className={cn("hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors", className)} {...props} />
  );
}

export function TableHead({ className, ...props }: React.ComponentProps<"th">): React.JSX.Element {
  return (
    <th
      className={cn(
        "text-muted-foreground h-10 px-3 text-left align-middle font-medium whitespace-nowrap",
        className,
      )}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }: React.ComponentProps<"td">): React.JSX.Element {
  return <td className={cn("p-3 align-middle whitespace-nowrap", className)} {...props} />;
}
